var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ResponsiveRowSwitch", {
    attrs: { dense: true },
    scopedSlots: _vm._u([
      {
        key: "status",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "pl-2 font-weight-bold",
                attrs: { color: _vm.status_color, hover: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle", !_vm.controlExpanded)
                  },
                },
              },
              [
                _c(
                  "v-card-text",
                  { staticClass: "pa-2 font-weight-bold" },
                  [
                    _vm._v(" " + _vm._s(_vm.control.root.hdf.status) + " "),
                    _c("v-icon", { staticClass: "float-right" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.controlExpanded
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          ) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "set",
        fn: function () {
          return [
            _c(
              "v-row",
              { staticClass: "pa-4" },
              [
                _c("div", {
                  staticClass: "pa-2 title",
                  style: _vm.$vuetify.breakpoint.lgAndUp
                    ? "width: 15vw"
                    : "width:20vw",
                  domProps: { textContent: _vm._s(_vm.filename) },
                }),
                _vm.isOverlaid
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "ml-2",
                                          staticStyle: { cursor: "pointer" },
                                        },
                                        "v-icon",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v("mdi-delta")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          746953196
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "This control has been modified in an overlay"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "severity",
        fn: function () {
          return [
            _c(
              "v-card-text",
              { staticClass: "pa-2" },
              [
                "severityoverride" in _vm.control.data.tags
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "span",
                                    _vm._g({}, on),
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            outlined: "",
                                            color: _vm.severity_color,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                size: "16",
                                                "data-cy": "severityOverride",
                                              },
                                            },
                                            [_vm._v(" mdi-delta ")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (
                                                  _vm.control.hdf.severity ||
                                                  "none"
                                                ).toUpperCase()
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3792295017
                        ),
                      },
                      [
                        _c("span", [
                          _c("span", [
                            _vm._v(" Severity has been overridden from "),
                            "severity" in _vm.control.data.tags
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.control.data.tags["severity"]
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("span", [_vm._v(" Unknown ")]),
                            _vm._v(
                              " to " +
                                _vm._s(
                                  _vm.control.data.tags["severityoverride"]
                                ) +
                                " "
                            ),
                            _c("br"),
                            "severityjustification" in _vm.control.data.tags
                              ? _c("span", [
                                  _vm._v(
                                    " Justification: " +
                                      _vm._s(
                                        _vm.control.data.tags[
                                          "severityjustification"
                                        ]
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(" No justification provided "),
                                ]),
                          ]),
                        ]),
                      ]
                    )
                  : _c(
                      "v-chip",
                      { attrs: { outlined: "", color: _vm.severity_color } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              (_vm.control.hdf.severity || "none").toUpperCase()
                            ) +
                            " "
                        ),
                      ]
                    ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "title",
        fn: function () {
          return [
            _c("div", {
              staticClass: "pa-2 title",
              domProps: {
                innerHTML: _vm._s(_vm.sanitize_html(_vm.control.data.title)),
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "id",
        fn: function () {
          return [
            _c("v-card-text", { staticClass: "pa-2 title font-weight-bold" }, [
              _c("div", [_vm._v(" " + _vm._s(_vm.control.data.id) + " ")]),
              _vm.showLegacy(_vm.control)
                ? _c("div", [
                    _vm._v(" " + _vm._s(_vm.showLegacy(_vm.control)) + " "),
                  ])
                : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "tags",
        fn: function () {
          return [
            _c(
              "v-chip-group",
              { attrs: { column: "" } },
              _vm._l(_vm.nistTags, function (tag, i) {
                return _c(
                  "v-tooltip",
                  {
                    key: "nist-chip" + i,
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-chip",
                                _vm._g(
                                  {
                                    attrs: { href: tag.url, target: "_blank" },
                                  },
                                  on
                                ),
                                [_vm._v(" " + _vm._s(tag.label) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(tag.description))])]
                )
              }),
              1
            ),
            _c(
              "v-chip-group",
              { attrs: { column: "" } },
              _vm._l(_vm.cciTags, function (tag, i) {
                return _c(
                  "v-tooltip",
                  {
                    key: "cci-chip" + i,
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-chip",
                                _vm._g({ staticStyle: { cursor: "help" } }, on),
                                [_vm._v(" " + _vm._s(tag.label) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(tag.description))])]
                )
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "runTime",
        fn: function () {
          return [
            _c("v-card-text", { staticClass: "pa-2 title font-weight-bold" }, [
              _vm._v(_vm._s(_vm.runTime)),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "viewed",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "py-0 my-0 fill-height" },
              [
                _c(
                  "v-layout",
                  {
                    staticClass: "py-0 my-0",
                    attrs: {
                      "justify-center": _vm.$vuetify.breakpoint.lgAndUp,
                      "align-center": _vm.$vuetify.breakpoint.lgAndUp,
                    },
                  },
                  [
                    _c("v-checkbox", {
                      staticClass: "align-center justify-center py-0 my-0 pl-0",
                      attrs: {
                        "hide-details": "",
                        label: _vm.$vuetify.breakpoint.lgAndUp ? "" : "Viewed",
                      },
                      model: {
                        value: _vm.wasViewed,
                        callback: function ($$v) {
                          _vm.wasViewed = $$v
                        },
                        expression: "wasViewed",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }